import * as flowActionTypes from "../actionTypes/flowActionTypes";

export const processExternalFlowUpdate = (id, updates) => ({
  type: flowActionTypes.PROCESS_EXTERNAL_FLOW_UPDATE,
  payload: {
    id,
    info: updates,
  },
});
